import React, { useState, useEffect } from 'react';
import LoadingScreen from './components/LoadingScreen';
import AppContent from './components/AppContent';
import { ColorSchemeProvider } from './contexts/ColorSchemeContext';
import { useTheme } from './contexts/ThemeContext';

const App = () => {
  const { mounted } = useTheme();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (mounted) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [mounted]);

  if (!mounted || isLoading) {
    return <LoadingScreen />;
  }

  return (
    <ColorSchemeProvider>
      <AppContent />
    </ColorSchemeProvider>
  );
};

export default App;
